import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
const userVuex = createNamespacedHelpers("user");
import formatter from "@utils/formatter";
const assetsVuex = createNamespacedHelpers("assets");
export default {
  name: "nCurrencyTwo",
  props: {
    isShowKey: {
      default: true
    },
    showkeyFnc: {
      default: null
    },
    isShowCoin: {
      default: true
    },
    showCoinFnc: {
      default: null
    },
    isShowTap: {
      default: false
    },
    showTapFnc: {
      default: null
    },
    isShowUsdt: {
      default: false
    },
    showUsdtFnc: {
      default: null
    },
    itemBg: {
      type: String,
      default: "#0000004d"
    }
  },
  computed: {
    ...walletVuex.mapState(["isMobile", "theme"]),
    ...userVuex.mapState(["userData"]),
    ...assetsVuex.mapState(["assetsList"]),
    fmt_pre() {
      return formatter.fmt_pre;
    }
  },
  data() {
    return {
      tonCurrency: {
        tap: {
          balance: null,
          icon: null
        },
        usdt: {
          balance: null,
          icon: null
        }
      }
    };
  },
  methods: {
    ...assetsVuex.mapActions(["getAssetsList"]),
    async getCurrencyData() {
      await this.getAssetsList();
      this.assetsList.map(item => {
        if (item.chain === "ton") {
          for (const key in this.tonCurrency) {
            if (item.name == key) {
              this.tonCurrency[key].balance = item.balance;
              this.tonCurrency[key].icon = item.icon;
            }
          }
        }
      });
    }
  }
};